<div class="loader-container">
    <div class="loader-card" role="status" aria-label="Loading">
        <div class="spinner-ring" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <img src="assets/images/common/favicon.png" alt="InventoryHQ" />
    </div>
</div>